import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, ErrorHandler } from '@angular/core';
import { KeyValue } from '@angular/common';
import { IApiResponse, IBreadCrumb } from '../models';
import { RouteConstants } from 'src/app/shared/constant';
import { TokenService } from './token.service';

@Injectable()
export class CommonService extends ApiService {
  constructor(
    http: HttpClient,
    errorHandler: ErrorHandler,
    private readonly tokenService: TokenService,
  ) {
    super(http, errorHandler);
  }

  public getState(id: number): Observable<KeyValue<number, string>[]> {
    return this.get(`common/state/${id}`);
  }

  public getCity(id: number): Observable<KeyValue<number, string>[]> {
    return this.get(`common/city/${id}`);
  }

  public getTimeZone(): Observable<KeyValue<number, string>[]> {
    return this.get(`common/timeZone`);
  }

  public bindDomain(id: number): Observable<IApiResponse<boolean>> {
    return this.put(`common/domain/${id}`, null);
  }

  public getBreadCrumb(id: number): IBreadCrumb[] {
    const client = this.tokenService.getToken();
    switch (id) {
      case RouteConstants.Route.Restaurant:
        return [
          {
            id: RouteConstants.Route.Restaurant,
            label: 'Restaurants',
            routerLink: '/home/restaurant',
          },
        ];
      case RouteConstants.Route.AddRestaurant:
        return [
          {
            id: RouteConstants.Route.Restaurant,
            label: 'Restaurants',
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.AddRestaurant,
            label: 'Add Restaurant',
            routerLink: '/home/add-restaurant',
          },
        ];
      case RouteConstants.Route.Outlet:
        return [
          {
            id: RouteConstants.Route.Outlet,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Outlet,
            label: 'Outlets',
            routerLink: '/home/outlet',
          },
        ];
      case RouteConstants.Route.AddOutlet:
        return [
          {
            id: RouteConstants.Route.Outlet,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Outlet,
            label: 'Outlets',
            routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.AddOutlet,
            label: 'Add Outlet',
            routerLink: '/home/add-outlet',
          },
        ];
      case RouteConstants.Route.Dashboard:
        return [
          {
            id: RouteConstants.Route.Dashboard,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Dashboard,
            label: client.out_name,
            routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.Dashboard,
            label: 'Dashboard',
            routerLink: '/home/dashboard',
          },
        ];
      case RouteConstants.Route.ApplicationUser:
        return [
          {
            id: RouteConstants.Route.User,
            label: 'User',
            routerLink: '',
          },
          {
            id: RouteConstants.Route.ApplicationUser,
            label: 'Application Users',
            routerLink: '/home/user-application',
          },
        ];
      case RouteConstants.Route.BlockedUser:
        return [
          {
            id: RouteConstants.Route.User,
            label: 'User',
            routerLink: '',
          },
          {
            id: RouteConstants.Route.BlockedUser,
            label: 'Blocked Users',
            routerLink: '/home/user-blocked',
          },
        ];
      case RouteConstants.Route.Search:
        return [
          {
            id: RouteConstants.Route.Search,
            label: 'Quick Search',
            routerLink: '/home/search',
          },
        ];
      case RouteConstants.Route.PaidDiagnostic:
        return [
          {
            id: RouteConstants.Route.Diagnostic,
            label: 'Diagnostic',
            routerLink: '',
          },
          {
            id: RouteConstants.Route.PaidDiagnostic,
            label: 'Paid Orders',
            routerLink: '/home/diagnostic-paid',
          },
        ];
      case RouteConstants.Route.UnPaidDiagnostic:
        return [
          {
            id: RouteConstants.Route.Diagnostic,
            label: 'Diagnostic',
            routerLink: '',
          },
          {
            id: RouteConstants.Route.UnPaidDiagnostic,
            label: 'Unpaid Orders',
            routerLink: '/home/diagnostic-unpaid',
          },
        ];
      case RouteConstants.Route.PendingDiagnostic:
        return [
          {
            id: RouteConstants.Route.Diagnostic,
            label: 'Diagnostic',
            routerLink: '',
          },
          {
            id: RouteConstants.Route.PendingDiagnostic,
            label: 'Pending Orders',
            routerLink: '/home/diagnostic-pending',
          },
        ];
      case RouteConstants.Route.OutletDiagnostic:
        return [
          {
            id: RouteConstants.Route.Diagnostic,
            label: 'Diagnostic',
            routerLink: '',
          },
          {
            id: RouteConstants.Route.OutletDiagnostic,
            label: 'Outlet Diagnostic',
            routerLink: '/home/diagnostic-outlet',
          },
        ];
      case RouteConstants.Route.Assignment:
        return [
          {
            id: RouteConstants.Route.User,
            label: 'Users',
            routerLink: '/home/user-application',
          },
          {
            id: RouteConstants.Route.User,
            label: 'Assignment',
            routerLink: '',
          },
        ];
      case RouteConstants.Route.MasterThirdParty:
        return [
          {
            id: RouteConstants.Route.Masters,
            label: 'Master',
            routerLink: '',
          },
          {
            id: RouteConstants.Route.MasterThirdParty,
            label: 'Third Party Services',
            routerLink: '/master/third-party',
          },
        ];
      case RouteConstants.Route.MasterMenuImageTag:
        return [
          {
            id: RouteConstants.Route.Masters,
            label: 'Master',
            routerLink: '',
          },
          {
            id: RouteConstants.Route.MasterMenuImageTag,
            label: 'Menu Image Tag',
            routerLink: '/master/menu-image',
          },
        ];
      case RouteConstants.Route.OrderReports:
        return [
          {
            id: RouteConstants.Route.Reports,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Reports,
            label: client.out_name,
            routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.OrderReports,
            label: 'Reporting',
            routerLink: '/report/order-report',
          },
        ];
      case RouteConstants.Route.ProductReports:
        return [
          {
            id: RouteConstants.Route.Reports,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Reports,
            label: client.out_name,
            routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.ProductReports,
            label: 'Reporting',
            routerLink: '/report/order-report',
          },
        ];
      case RouteConstants.Route.MarketingReports:
        return [
          {
            id: RouteConstants.Route.Reports,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Reports,
            label: client.out_name,
            routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.MarketingReports,
            label: 'Marketing',
            routerLink: '/report/marketing-report',
          },
        ];
      case RouteConstants.Route.MenuReports:
        return [
          {
            id: RouteConstants.Route.Reports,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Reports,
            label: client.out_name,
            routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.MenuReports,
            label: 'Menu',
            routerLink: '/report/menu-report',
          },
        ];
      case RouteConstants.Route.VisitorReports:
        return [
          {
            id: RouteConstants.Route.Reports,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Reports,
            label: client.out_name,
            routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.VisitorReports,
            label: 'Visitor',
            routerLink: '/report/visitor-report',
          },
        ];
      case RouteConstants.Route.MemberCustomer:
        return [
          {
            id: RouteConstants.Route.Customer,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.MemberCustomer,
            label: 'Customers (Member)',
            routerLink: '/home/customer-member',
          },
        ];
      case RouteConstants.Route.GuestCustomer:
        return [
          {
            id: RouteConstants.Route.Customer,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.GuestCustomer,
            label: 'Customers (Guest)',
            routerLink: '/home/customer-guest',
          },
        ];
      case RouteConstants.Route.BlockedCustomer:
        return [
          {
            id: RouteConstants.Route.Customer,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.BlockedCustomer,
            label: 'Customers (Blocked)',
            routerLink: '/home/customer-blocked',
          },
        ];
      case RouteConstants.Route.Rewards:
        return [
          {
            id: RouteConstants.Route.Rewards,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Rewards,
            label: 'Rewards',
            routerLink: '/home/reward',
          },
        ];
      case RouteConstants.Route.AppNotification:
        return [
          {
            id: RouteConstants.Route.Notification,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.AppNotification,
            label: 'Notifications',
            routerLink: '/home/notification-app',
          },
        ];
      case RouteConstants.Route.PushNotification:
        return [
          {
            id: RouteConstants.Route.Notification,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.PushNotification,
            label: 'Notifications',
            routerLink: '/home/notification-push',
          },
        ];
      case RouteConstants.Route.Banner:
        return [
          {
            id: RouteConstants.Route.Banner,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Banner,
            label: 'Banners',
            routerLink: '/home/banner',
          },
        ];
      case RouteConstants.Route.Gallery:
        return [
          {
            id: RouteConstants.Route.Gallery,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Gallery,
            label: 'Item Gallery',
            routerLink: '/home/gallery',
          },
        ];
      case RouteConstants.Route.Coupon:
        return [
          {
            id: RouteConstants.Route.Coupon,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Coupon,
            label: client.out_name,
            routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.Coupon,
            label: 'Coupons',
            routerLink: '/home/coupon',
          },
        ];
      case RouteConstants.Route.Event:
        return [
          {
            id: RouteConstants.Route.Event,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Event,
            label: client.out_name,
            routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.Event,
            label: 'Events',
            routerLink: '/home/event',
          },
        ];
      case RouteConstants.Route.Reservation:
        return [
          {
            id: RouteConstants.Route.Reservation,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Reservation,
            label: client.out_name,
            routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.Reservation,
            label: 'Reservations',
            routerLink: '/home/reservation',
          },
        ];
      case RouteConstants.Route.TableOrdering:
        return [
          {
            id: RouteConstants.Route.TableOrdering,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.TableOrdering,
            label: client.out_name,
            routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.TableOrdering,
            label: 'Table Ordering',
            routerLink: '/home/table',
          },
        ];
      case RouteConstants.Route.KioskList:
        return [
          {
            id: RouteConstants.Route.Kiosk,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Kiosk,
            label: client.out_name,
            routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.KioskList,
            label: 'Kiosk',
            routerLink: '/home/kiosk-list',
          },
        ];
      case RouteConstants.Route.KioskBanner:
        return [
          {
            id: RouteConstants.Route.Kiosk,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Kiosk,
            label: client.out_name,
            routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.KioskBanner,
            label: 'Kiosk',
            routerLink: '/home/kiosk-banner',
          },
        ];
      case RouteConstants.Route.Order:
        return [
          {
            id: RouteConstants.Route.Order,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Order,
            label: client.out_name,
            routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.Order,
            label: 'Orders',
            routerLink: '/home/order',
          },
        ];
      case RouteConstants.Route.MenuItem:
        return [
          {
            id: RouteConstants.Route.Menu,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Menu,
            label: client.out_name,
            routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.MenuItem,
            label: 'Menu',
            routerLink: '/home/menu-item',
          },
        ];
      case RouteConstants.Route.MenuModifier:
        return [
          {
            id: RouteConstants.Route.Menu,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Menu,
            label: client.out_name,
            routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.MenuModifier,
            label: 'Modifier',
            routerLink: '/home/menu-modifier',
          },
        ];
      case RouteConstants.Route.Product:
        return [
          {
            id: RouteConstants.Route.Giftcard,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Giftcard,
            label: client.out_name,
            routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.Giftcard,
            label: 'Giftcard',
            // routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.Product,
            label: 'Product',
            routerLink: '/giftcard/product',
          },
        ];
      case RouteConstants.Route.ProductFee:
        return [
          {
            id: RouteConstants.Route.Giftcard,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Giftcard,
            label: client.out_name,
            routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.Giftcard,
            label: 'Giftcard',
            // routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.ProductFee,
            label: 'Fee',
            routerLink: '/giftcard/fee',
          },
        ];
      case RouteConstants.Route.ProductCoupon:
        return [
          {
            id: RouteConstants.Route.Giftcard,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Giftcard,
            label: client.out_name,
            routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.Giftcard,
            label: 'Giftcard',
            // routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.ProductCoupon,
            label: 'Coupon',
            routerLink: '/giftcard/coupon',
          },
        ];
      case RouteConstants.Route.ProductSell:
        return [
          {
            id: RouteConstants.Route.Giftcard,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Giftcard,
            label: client.out_name,
            routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.Giftcard,
            label: 'Giftcard',
            // routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.ProductSell,
            label: 'Sell',
            routerLink: '/giftcard/sell',
          },
        ];
      case RouteConstants.Route.ProductRedeem:
        return [
          {
            id: RouteConstants.Route.Giftcard,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Giftcard,
            label: client.out_name,
            routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.Giftcard,
            label: 'Giftcard',
            // routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.ProductRedeem,
            label: 'Redeem',
            routerLink: '/giftcard/redeem',
          },
        ];
      case RouteConstants.Route.ProductSearch:
        return [
          {
            id: RouteConstants.Route.Giftcard,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Giftcard,
            label: client.out_name,
            routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.Giftcard,
            label: 'Giftcard',
            // routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.ProductSearch,
            label: 'Search',
            routerLink: '/giftcard/search',
          },
        ];
      case RouteConstants.Route.Feature:
        return [
          {
            id: RouteConstants.Route.Feature,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Feature,
            label: client.out_name,
            routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.Feature,
            label: 'Features',
            routerLink: '/setting/feature',
          },
        ];
      case RouteConstants.Route.FeatureDetail:
        return [
          {
            id: RouteConstants.Route.Feature,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Feature,
            label: client.out_name,
            routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.Feature,
            label: 'Features',
            routerLink: '/setting/feature',
          },
          {
            id: RouteConstants.Route.FeatureDetail,
            label: 'Feature-Details',
            routerLink: '/setting/feature-detail',
          },
        ];
      case RouteConstants.Route.PaymentMode:
        return [
          {
            id: RouteConstants.Route.Feature,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Feature,
            label: client.out_name,
            routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.Feature,
            label: 'Features',
            routerLink: '/setting/feature',
          },
          {
            id: RouteConstants.Route.PaymentMode,
            label: 'Payment-Modes',
            routerLink: '/setting/payment-mode',
          },
        ];
      case RouteConstants.Route.ShipDay:
        return [
          {
            id: RouteConstants.Route.Feature,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Feature,
            label: client.out_name,
            routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.Feature,
            label: 'Features',
            routerLink: '/setting/feature',
          },
          {
            id: RouteConstants.Route.ShipDay,
            label: 'Ship-Day',
            routerLink: '/setting/ship-day',
          },
        ];
      case RouteConstants.Route.ExternalIntegration:
        return [
          {
            id: RouteConstants.Route.Feature,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Feature,
            label: client.out_name,
            routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.Feature,
            label: 'Features',
            routerLink: '/setting/feature',
          },
          {
            id: RouteConstants.Route.ExternalIntegration,
            label: 'External Integration',
            routerLink: '/setting/external-setting',
          },
        ];
      case RouteConstants.Route.Profile:
        return [
          {
            id: RouteConstants.Route.Setting,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Setting,
            label: client.out_name,
            routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.Setting,
            label: 'Settings',
            // routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.Profile,
            label: 'Outlet-Profile',
            routerLink: '/setting/tip',
          },
        ];
      case RouteConstants.Route.Tip:
        return [
          {
            id: RouteConstants.Route.Setting,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Setting,
            label: client.out_name,
            routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.Setting,
            label: 'Settings',
            // routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.Tip,
            label: 'Tip',
            routerLink: '/setting/tip',
          },
        ];
      case RouteConstants.Route.Fee:
        return [
          {
            id: RouteConstants.Route.Setting,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Setting,
            label: client.out_name,
            routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.Setting,
            label: 'Settings',
            // routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.Fee,
            label: 'Fee',
            routerLink: '/setting/fee',
          },
        ];
      case RouteConstants.Route.Tax:
        return [
          {
            id: RouteConstants.Route.Setting,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Setting,
            label: client.out_name,
            routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.Setting,
            label: 'Settings',
            // routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.Tax,
            label: 'Tax',
            routerLink: '/setting/tax',
          },
        ];
      case RouteConstants.Route.ShipDayForm:
        return [
          {
            id: RouteConstants.Route.Setting,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Setting,
            label: client.out_name,
            routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.Setting,
            label: 'Settings',
            // routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.ShipDayForm,
            label: 'ShipDay Form',
            routerLink: '/setting/shipday-form',
          },
        ];
      case RouteConstants.Route.Hour:
        return [
          {
            id: RouteConstants.Route.Setting,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Setting,
            label: client.out_name,
            routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.Setting,
            label: 'Settings',
            // routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.Hour,
            label: 'Opening Hours',
            routerLink: '/setting/hour',
          },
        ];
      case RouteConstants.Route.SpecialHour:
        return [
          {
            id: RouteConstants.Route.Setting,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Setting,
            label: client.out_name,
            routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.Setting,
            label: 'Settings',
            // routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.SpecialHour,
            label: 'Special Hours',
            routerLink: '/setting/special-hour',
          },
        ];
      case RouteConstants.Route.DeliveryPickup:
        return [
          {
            id: RouteConstants.Route.Setting,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Setting,
            label: client.out_name,
            routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.Setting,
            label: 'Settings',
            // routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.DeliveryPickup,
            label: 'Delivery & Pickup',
            routerLink: '/setting/delivery-pickup',
          },
        ];
      case RouteConstants.Route.ThirdParty:
        return [
          {
            id: RouteConstants.Route.Setting,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Setting,
            label: client.out_name,
            routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.Setting,
            label: 'Settings',
            // routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.ThirdParty,
            label: 'Third Party Delivery',
            routerLink: '/setting/third-party',
          },
        ];
      case RouteConstants.Route.Curbside:
        return [
          {
            id: RouteConstants.Route.Setting,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Setting,
            label: client.out_name,
            routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.Setting,
            label: 'Settings',
            // routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.Curbside,
            label: 'Curbside',
            routerLink: '/setting/curbside',
          },
        ];
      case RouteConstants.Route.DeliveryZone:
        return [
          {
            id: RouteConstants.Route.Setting,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Setting,
            label: client.out_name,
            routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.Setting,
            label: 'Settings',
            // routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.DeliveryZone,
            label: 'Delivery Zone',
            routerLink: '/setting/delivery-zone',
          },
        ];
      case RouteConstants.Route.CateringSetting:
        return [
          {
            id: RouteConstants.Route.Catering,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Catering,
            label: client.out_name,
            routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.CateringSetting,
            label: 'Settings',
            routerLink: '/catering/setting',
          },
        ];
      case RouteConstants.Route.CateringMenu:
        return [
          {
            id: RouteConstants.Route.Catering,
            label: client.rest_name,
            routerLink: '/home/restaurant',
          },
          {
            id: RouteConstants.Route.Catering,
            label: client.out_name,
            routerLink: '/home/outlet',
          },
          {
            id: RouteConstants.Route.CateringMenu,
            label: 'Menu',
            routerLink: '/catering/menu',
          },
        ];

      default:
        return [];
    }
  }
}
